import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { FieldType, FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { FormlyMaterialModule } from '@ngx-formly/material';
import { TextProps } from 'app/core/json-schema-controls/models/text-props.model';
import { JsonSchemaService } from 'app/core/json-schema-controls/services/json-schema.service';

@Component({
  selector: 'hmt-label-type',
  standalone: true,
  imports: [CommonModule, MatTabsModule, FormlyMaterialModule, FormlyModule],
  templateUrl: './label-type.component.html',
  styleUrl: './label-type.component.scss',
})
export class LabelTypeComponent extends FieldType<FormlyFieldConfig<TextProps>> {
  constructor(private readonly jsonSchemaService: JsonSchemaService) {
    super();
  }

  get styleObject() {
    return this.jsonSchemaService.cssStringToObject(this.props?.style || '');
  }
}
